/*

 * DH Commerce OS v1.4

 * Recommendation Engine

 * File: dh-commerce-recommendations.js

 *

 * Generic, reusable, storefront-agnostic recommendation engine.

 * No DOM mutations occur in this file. The engine remains dormant until

 * configuration or bootstrap code registers data and calls recommend().

 */

 

(function (window, document) {

  "use strict";

 

  var ROOT_NAME = "DHCommerce";

  var ENGINE_NAME = "recommendationEngine";

  var VERSION = "1.4.0";

 

  var root = window[ROOT_NAME] = window[ROOT_NAME] || {};

 

  if (root[ENGINE_NAME] && root[ENGINE_NAME].version) {

    return;

  }

 

  var DEFAULTS = Object.freeze({

    limit: 8,

    placement: "default",

    strategy: "hybrid",

    minimumScore: Number.NEGATIVE_INFINITY,

    excludeUnavailable: true,

    excludeAlreadyInCart: true,

    excludeCurrentProduct: true,

    deterministic: true,

    returningVisitorWeight: 1.08,

    recentViewDecay: 0.82,

    weights: Object.freeze({

      manualBoost: 1,

      manualPenalty: 1,

      productAffinity: 14,

      categoryAffinity: 9,

      flavorAffinity: 7,

      dietaryCompatibility: 12,

      crossSell: 18,

      related: 13,

      recentlyViewed: 6,

      returningVisitor: 4,

      popularity: 2,

      recency: 1

    })

  });

 

  var registries = {

    recommendations: new Map(),

    products: new Map(),

    categories: new Map(),

    strategies: new Map()

  };

 

  var cache = new Map();

  var sequence = 0;

 

  function isObject(value) {

    return value !== null && typeof value === "object" && !Array.isArray(value);

  }

 

  function clone(value) {

    if (value === undefined) return undefined;

    try {

      return JSON.parse(JSON.stringify(value));

    } catch (error) {

      if (Array.isArray(value)) return value.slice();

      if (isObject(value)) return Object.assign({}, value);

      return value;

    }

  }

 

  function deepMerge(target) {

    var output = isObject(target) ? Object.assign({}, target) : {};

 

    for (var i = 1; i < arguments.length; i += 1) {

      var source = arguments[i];

      if (!isObject(source)) continue;

 

      Object.keys(source).forEach(function (key) {

        var sourceValue = source[key];

        var targetValue = output[key];

 

        if (isObject(sourceValue) && isObject(targetValue)) {

          output[key] = deepMerge(targetValue, sourceValue);

        } else if (Array.isArray(sourceValue)) {

          output[key] = sourceValue.slice();

        } else {

          output[key] = sourceValue;

        }

      });

    }

 

    return output;

  }

 

  function toArray(value) {

    if (value === undefined || value === null) return [];

    return Array.isArray(value) ? value.slice() : [value];

  }

 

  function unique(values) {

    return Array.from(new Set(toArray(values).filter(function (value) {

      return value !== undefined && value !== null && value !== "";

    })));

  }

 

  function normalizeId(value) {

    if (value === undefined || value === null) return "";

    return String(value).trim();

  }

 

  function normalizeToken(value) {

    return normalizeId(value).toLowerCase();

  }

 

  function numberOr(value, fallback) {

    var parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : fallback;

  }

 

  function now() {

    return Date.now();

  }

 

  function stableHash(input) {

    var string = String(input || "");

    var hash = 2166136261;

 

    for (var i = 0; i < string.length; i += 1) {

      hash ^= string.charCodeAt(i);

      hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);

    }

 

    return hash >>> 0;

  }

 

  function emit(name, detail) {

    var payload = clone(detail || {});

    payload.engine = ENGINE_NAME;

    payload.version = VERSION;

    payload.timestamp = new Date().toISOString();

 

    if (root.events && typeof root.events.emit === "function") {

      try {

        root.events.emit(name, payload);

        return;

      } catch (error) {

        // Fall through to DOM event dispatch.

      }

    }

 

    if (document && typeof document.dispatchEvent === "function" && typeof window.CustomEvent === "function") {

      document.dispatchEvent(new window.CustomEvent(name, { detail: payload }));

      document.dispatchEvent(new window.CustomEvent("dhcommerce", {

        detail: Object.assign({ type: name }, payload)

      }));

    }

  }

 

  function warn(message, context) {

    if (root.logger && typeof root.logger.warn === "function") {

      root.logger.warn("[DHCommerce recommendations] " + message, context || {});

      return;

    }

 

    if (window.console && typeof window.console.warn === "function") {

      window.console.warn("[DHCommerce recommendations] " + message, context || "");

    }

  }

 

  function readPath(object, path, fallback) {

    if (!path) return object;

 

    var parts = Array.isArray(path) ? path : String(path).split(".");

    var cursor = object;

 

    for (var i = 0; i < parts.length; i += 1) {

      if (cursor === undefined || cursor === null) return fallback;

      cursor = cursor[parts[i]];

    }

 

    return cursor === undefined ? fallback : cursor;

  }

 

  function normalizeProduct(product) {

    if (!isObject(product)) {

      throw new TypeError("Product must be an object.");

    }

 

    var id = normalizeId(product.id || product.productId || product.handle || product.sku);

    if (!id) {

      throw new Error("Product requires id, productId, handle, or sku.");

    }

 

    var categoryIds = unique(

      toArray(product.categoryIds || product.categories || product.categoryId || product.category)

        .map(normalizeId)

        .filter(Boolean)

    );

 

    var dietaryTags = unique(

      toArray(product.dietaryTags || product.dietary || product.preferences)

        .map(normalizeToken)

        .filter(Boolean)

    );

 

    var flavorTags = unique(

      toArray(product.flavorTags || product.flavors || product.flavor)

        .map(normalizeToken)

        .filter(Boolean)

    );

 

    var tags = unique(

      toArray(product.tags).map(normalizeToken).filter(Boolean)

    );

 

    return deepMerge({}, product, {

      id: id,

      categoryIds: categoryIds,

      dietaryTags: dietaryTags,

      flavorTags: flavorTags,

      tags: tags,

      available: product.available !== false,

      crossSellIds: unique(toArray(product.crossSellIds || product.crossSells).map(normalizeId)),

      relatedIds: unique(toArray(product.relatedIds || product.related).map(normalizeId)),

      manualBoost: numberOr(product.manualBoost, 0),

      manualPenalty: numberOr(product.manualPenalty, 0),

      popularity: numberOr(product.popularity, 0),

      createdAt: product.createdAt || null,

      metadata: isObject(product.metadata) ? clone(product.metadata) : {}

    });

  }

 

  function normalizeCategory(category) {

    if (!isObject(category)) {

      throw new TypeError("Category must be an object.");

    }

 

    var id = normalizeId(category.id || category.categoryId || category.handle || category.name);

    if (!id) throw new Error("Category requires an id.");

 

    return deepMerge({}, category, {

      id: id,

      productIds: unique(toArray(category.productIds || category.products).map(normalizeId)),

      relatedCategoryIds: unique(toArray(category.relatedCategoryIds || category.related).map(normalizeId)),

      manualBoost: numberOr(category.manualBoost, 0),

      metadata: isObject(category.metadata) ? clone(category.metadata) : {}

    });

  }

 

  function normalizeDefinition(definition) {

    if (!isObject(definition)) {

      throw new TypeError("Recommendation definition must be an object.");

    }

 

    var id = normalizeId(definition.id || definition.name);

    if (!id) throw new Error("Recommendation definition requires an id.");

 

    return deepMerge({}, definition, {

      id: id,

      enabled: definition.enabled !== false,

      placement: normalizeId(definition.placement || "default"),

      strategy: definition.strategy || "hybrid",

      productIds: unique(toArray(definition.productIds || definition.products).map(normalizeId)),

      categoryIds: unique(toArray(definition.categoryIds || definition.categories).map(normalizeId)),

      excludeIds: unique(toArray(definition.excludeIds || definition.exclusions).map(normalizeId)),

      manualBoosts: isObject(definition.manualBoosts) ? clone(definition.manualBoosts) : {},

      manualPenalties: isObject(definition.manualPenalties) ? clone(definition.manualPenalties) : {},

      limit: Math.max(0, Math.floor(numberOr(definition.limit, DEFAULTS.limit))),

      metadata: isObject(definition.metadata) ? clone(definition.metadata) : {}

    });

  }

 

  function registerProduct(product) {

    var normalized = normalizeProduct(product);

    registries.products.set(normalized.id, normalized);

    cache.clear();

    return clone(normalized);

  }

 

  function registerProducts(products) {

    return toArray(products).map(registerProduct);

  }

 

  function registerCategory(category) {

    var normalized = normalizeCategory(category);

    registries.categories.set(normalized.id, normalized);

    cache.clear();

    return clone(normalized);

  }

 

  function registerCategories(categories) {

    return toArray(categories).map(registerCategory);

  }

 

  function register(definition) {

    var normalized = normalizeDefinition(definition);

    registries.recommendations.set(normalized.id, normalized);

    cache.clear();

    return clone(normalized);

  }

 

  function registerMany(definitions) {

    return toArray(definitions).map(register);

  }

 

  function remove(id) {

    var normalizedId = normalizeId(id);

    var removed = registries.recommendations.delete(normalizedId);

    cache.clear();

    return removed;

  }

 

  function clear() {

    registries.recommendations.clear();

    registries.products.clear();

    registries.categories.clear();

    cache.clear();

    sequence = 0;

    return true;

  }

 

  function get(id) {

    var item = registries.recommendations.get(normalizeId(id));

    return item ? clone(item) : null;

  }

 

  function getAll() {

    return Array.from(registries.recommendations.values()).map(clone);

  }

 

  function getProduct(id) {

    var item = registries.products.get(normalizeId(id));

    return item ? clone(item) : null;

  }

 

  function getProducts() {

    return Array.from(registries.products.values()).map(clone);

  }

 

  function getCategory(id) {

    var item = registries.categories.get(normalizeId(id));

    return item ? clone(item) : null;

  }

 

  function getCategories() {

    return Array.from(registries.categories.values()).map(clone);

  }

 

  function resolveState(context) {

    var state = root.state || {};

    var personalization = root.personalizationEngine || {};

 

    var profile = context.profile;

    if (!profile && typeof personalization.getProfile === "function") {

      try { profile = personalization.getProfile(); } catch (error) { profile = null; }

    }

 

    profile = profile || readPath(state, "shopper.profile", {}) || {};

 

    var cartItems = context.cartItems || readPath(state, "cart.items", []) || [];

    var viewedProducts = context.recentlyViewed || profile.recentProducts || readPath(state, "history.products", []) || [];

    var viewedCategories = context.recentCategories || profile.recentCategories || readPath(state, "history.categories", []) || [];

 

    return {

      profile: isObject(profile) ? profile : {},

      cartItems: toArray(cartItems),

      recentlyViewed: toArray(viewedProducts),

      recentCategories: toArray(viewedCategories),

      returningVisitor: context.returningVisitor !== undefined

        ? Boolean(context.returningVisitor)

        : Boolean(profile.returningVisitor || readPath(state, "shopper.returningVisitor", false)),

      currentProductId: normalizeId(context.currentProductId || readPath(state, "product.id", "")),

      currentCategoryId: normalizeId(context.currentCategoryId || readPath(state, "category.id", ""))

    };

  }

 

  function extractIds(items) {

    return unique(toArray(items).map(function (item) {

      if (isObject(item)) return normalizeId(item.productId || item.id || item.handle || item.sku);

      return normalizeId(item);

    }).filter(Boolean));

  }

 

  function mapAffinity(value) {

    if (!value) return {};

    if (isObject(value)) return value;

 

    var output = {};

    toArray(value).forEach(function (item) {

      if (isObject(item)) {

        var key = normalizeId(item.id || item.key || item.name);

        if (key) output[key] = numberOr(item.score || item.weight || item.value, 1);

      } else {

        var token = normalizeId(item);

        if (token) output[token] = 1;

      }

    });

    return output;

  }

 

  function intersects(left, right) {

    var rightSet = new Set(toArray(right).map(normalizeToken));

    return toArray(left).some(function (value) {

      return rightSet.has(normalizeToken(value));

    });

  }

 

  function sumAffinity(keys, affinityMap) {

    return toArray(keys).reduce(function (total, key) {

      return total + numberOr(affinityMap[normalizeId(key)] || affinityMap[normalizeToken(key)], 0);

    }, 0);

  }

 

  function passesRuleEngine(candidate, context, definition) {

    if (!root.ruleEngine || typeof root.ruleEngine.evaluate !== "function") return true;

 

    var ruleIds = unique(

      toArray(definition.ruleIds || definition.rules)

        .concat(toArray(context.ruleIds || context.rules))

    );

 

    if (!ruleIds.length) return true;

 

    try {

      var result = root.ruleEngine.evaluate(ruleIds, {

        candidate: clone(candidate),

        context: clone(context),

        recommendation: clone(definition)

      });

 

      if (result === false) return false;

      if (isObject(result) && result.eligible === false) return false;

      if (isObject(result) && result.passed === false) return false;

      return true;

    } catch (error) {

      warn("Rule engine evaluation failed; candidate retained.", {

        candidateId: candidate.id,

        error: error && error.message

      });

      return true;

    }

  }

 

  function generateCandidates(definition, context) {

    var candidateIds = new Set();

    var explicitIds = unique(toArray(context.productIds).concat(definition.productIds));

 

    if (explicitIds.length) {

      explicitIds.forEach(function (id) { candidateIds.add(id); });

    } else {

      registries.products.forEach(function (product, id) {

        candidateIds.add(id);

      });

    }

 

    var categoryIds = unique(toArray(context.categoryIds).concat(definition.categoryIds));

    categoryIds.forEach(function (categoryId) {

      var category = registries.categories.get(categoryId);

      if (category) category.productIds.forEach(function (id) { candidateIds.add(id); });

 

      registries.products.forEach(function (product) {

        if (product.categoryIds.indexOf(categoryId) !== -1) candidateIds.add(product.id);

      });

    });

 

    var seedIds = unique(

      toArray(context.seedProductIds)

        .concat(extractIds(context.cartItems))

        .concat(context.currentProductId ? [context.currentProductId] : [])

    );

 

    seedIds.forEach(function (seedId) {

      var seed = registries.products.get(seedId);

      if (!seed) return;

      seed.crossSellIds.forEach(function (id) { candidateIds.add(id); });

      seed.relatedIds.forEach(function (id) { candidateIds.add(id); });

    });

 

    return Array.from(candidateIds)

      .map(function (id) { return registries.products.get(id); })

      .filter(Boolean);

  }

 

  function createScoreCard(candidate) {

    return {

      id: candidate.id,

      score: 0,

      reasons: [],

      components: {},

      candidate: candidate

    };

  }

 

  function addScore(card, key, rawValue, weight, reason) {

    var value = numberOr(rawValue, 0);

    var weighted = value * numberOr(weight, 0);

 

    if (!weighted) return;

 

    card.score += weighted;

    card.components[key] = numberOr(card.components[key], 0) + weighted;

    if (reason) card.reasons.push(reason);

  }

 

  function scoreCandidate(candidate, definition, context, resolved, options) {

    var card = createScoreCard(candidate);

    var weights = options.weights;

    var profile = resolved.profile;

 

    var productAffinity = mapAffinity(

      context.productAffinity || profile.productAffinity || profile.affinityProducts

    );

    var categoryAffinity = mapAffinity(

      context.categoryAffinity || profile.categoryAffinity || profile.affinityCategories

    );

    var flavorAffinity = mapAffinity(

      context.flavorAffinity || profile.flavorAffinity || profile.affinityFlavors

    );

 

    var dietaryPreferences = unique(

      toArray(context.dietaryPreferences)

        .concat(toArray(profile.dietaryPreferences || profile.dietary || profile.preferences))

        .map(normalizeToken)

    );

 

    addScore(

      card,

      "manualBoost",

      candidate.manualBoost + numberOr(definition.manualBoosts[candidate.id], 0) + numberOr(context.manualBoosts && context.manualBoosts[candidate.id], 0),

      weights.manualBoost,

      "manual-boost"

    );

 

    addScore(

      card,

      "manualPenalty",

      -(candidate.manualPenalty + numberOr(definition.manualPenalties[candidate.id], 0) + numberOr(context.manualPenalties && context.manualPenalties[candidate.id], 0)),

      weights.manualPenalty,

      "manual-penalty"

    );

 

    addScore(card, "productAffinity", sumAffinity([candidate.id], productAffinity), weights.productAffinity, "product-affinity");

    addScore(card, "categoryAffinity", sumAffinity(candidate.categoryIds, categoryAffinity), weights.categoryAffinity, "category-affinity");

    addScore(card, "flavorAffinity", sumAffinity(candidate.flavorTags, flavorAffinity), weights.flavorAffinity, "flavor-affinity");

 

    if (dietaryPreferences.length && candidate.dietaryTags.length) {

      var matches = candidate.dietaryTags.filter(function (tag) {

        return dietaryPreferences.indexOf(normalizeToken(tag)) !== -1;

      }).length;

      var compatibility = matches / dietaryPreferences.length;

      addScore(card, "dietaryCompatibility", compatibility, weights.dietaryCompatibility, "diet-compatible");

    }

 

    var seedIds = unique(

      toArray(context.seedProductIds)

        .concat(extractIds(resolved.cartItems))

        .concat(resolved.currentProductId ? [resolved.currentProductId] : [])

    );

 

    seedIds.forEach(function (seedId) {

      var seed = registries.products.get(seedId);

      if (!seed) return;

      if (seed.crossSellIds.indexOf(candidate.id) !== -1) {

        addScore(card, "crossSell", 1, weights.crossSell, "cross-sell");

      }

      if (seed.relatedIds.indexOf(candidate.id) !== -1) {

        addScore(card, "related", 1, weights.related, "related-product");

      }

      if (intersects(seed.categoryIds, candidate.categoryIds)) {

        addScore(card, "relatedCategory", 0.35, weights.related, "shared-category");

      }

      if (intersects(seed.flavorTags, candidate.flavorTags)) {

        addScore(card, "relatedFlavor", 0.45, weights.flavorAffinity, "shared-flavor");

      }

    });

 

    var recentIds = extractIds(resolved.recentlyViewed);

    var recentIndex = recentIds.indexOf(candidate.id);

    if (recentIndex !== -1) {

      addScore(

        card,

        "recentlyViewed",

        Math.pow(options.recentViewDecay, recentIndex),

        weights.recentlyViewed,

        "recently-viewed"

      );

    }

 

    if (resolved.returningVisitor) {

      var returningSignal = recentIndex !== -1 || sumAffinity([candidate.id], productAffinity) > 0 ? 1 : 0.25;

      addScore(card, "returningVisitor", returningSignal, weights.returningVisitor, "returning-visitor");

      card.score *= options.returningVisitorWeight;

    }

 

    addScore(card, "popularity", candidate.popularity, weights.popularity, "popularity");

 

    if (candidate.createdAt) {

      var created = new Date(candidate.createdAt).getTime();

      if (Number.isFinite(created)) {

        var ageDays = Math.max(0, (now() - created) / 86400000);

        addScore(card, "recency", 1 / (1 + ageDays / 30), weights.recency, "recency");

      }

    }

 

    if (typeof context.score === "function") {

      try {

        addScore(card, "custom", context.score(clone(candidate), clone(card), clone(resolved)), 1, "custom-score");

      } catch (error) {

        warn("Custom score function failed.", { candidateId: candidate.id, error: error && error.message });

      }

    }

 

    return card;

  }

 

  function filterCandidates(candidates, definition, context, resolved, options) {

    var exclusions = new Set(

      unique(

        definition.excludeIds

          .concat(toArray(context.excludeIds || context.exclusions).map(normalizeId))

      )

    );

 

    var cartIds = new Set(extractIds(resolved.cartItems));

 

    return candidates.filter(function (candidate) {

      if (exclusions.has(candidate.id)) return false;

      if (options.excludeUnavailable && candidate.available === false) return false;

      if (options.excludeAlreadyInCart && cartIds.has(candidate.id)) return false;

      if (options.excludeCurrentProduct && resolved.currentProductId && candidate.id === resolved.currentProductId) return false;

 

      if (typeof context.filter === "function") {

        try {

          if (context.filter(clone(candidate), clone(resolved)) === false) return false;

        } catch (error) {

          warn("Custom filter failed; candidate excluded.", { candidateId: candidate.id, error: error && error.message });

          return false;

        }

      }

 

      return passesRuleEngine(candidate, context, definition);

    });

  }

 

  function deterministicCompare(a, b, seed) {

    if (b.score !== a.score) return b.score - a.score;

 

    var aPriority = numberOr(a.candidate.priority, 0);

    var bPriority = numberOr(b.candidate.priority, 0);

    if (bPriority !== aPriority) return bPriority - aPriority;

 

    var aHash = stableHash(seed + "|" + a.id);

    var bHash = stableHash(seed + "|" + b.id);

    if (aHash !== bHash) return aHash - bHash;

 

    return a.id.localeCompare(b.id);

  }

 

  function rank(items, options) {

    var settings = deepMerge({}, {

      seed: "dhcommerce",

      deterministic: true,

      minimumScore: Number.NEGATIVE_INFINITY,

      limit: null

    }, options || {});

 

    var ranked = toArray(items)

      .filter(Boolean)

      .filter(function (item) { return numberOr(item.score, 0) >= settings.minimumScore; })

      .slice();

 

    ranked.sort(function (a, b) {

      if (settings.deterministic === false) return numberOr(b.score, 0) - numberOr(a.score, 0);

      return deterministicCompare(a, b, settings.seed);

    });

 

    if (Number.isFinite(settings.limit)) {

      ranked = ranked.slice(0, Math.max(0, Math.floor(settings.limit)));

    }

 

    return ranked.map(clone);

  }

 

  function resolveDefinition(request) {

    var id = normalizeId(request.id || request.recommendationId);

    var stored = id ? registries.recommendations.get(id) : null;

 

    if (stored) return deepMerge({}, stored, request.definition || {});

 

    return normalizeDefinition(deepMerge({}, {

      id: id || "adhoc-" + (++sequence),

      placement: request.placement || DEFAULTS.placement,

      strategy: request.strategy || DEFAULTS.strategy,

      limit: request.limit || DEFAULTS.limit

    }, request.definition || {}));

  }

 

  function cacheKey(definition, request, resolved, options) {

    if (request.cache === false) return "";

 

    var keyPayload = {

      id: definition.id,

      placement: options.placement,

      strategy: options.strategy,

      limit: options.limit,

      currentProductId: resolved.currentProductId,

      currentCategoryId: resolved.currentCategoryId,

      cartIds: extractIds(resolved.cartItems),

      recentIds: extractIds(resolved.recentlyViewed),

      productIds: toArray(request.productIds),

      categoryIds: toArray(request.categoryIds),

      excludeIds: toArray(request.excludeIds)

    };

 

    return JSON.stringify(keyPayload);

  }

 

  function formatResult(card, index, definition, options) {

    return {

      id: card.id,

      rank: index + 1,

      score: Number(card.score.toFixed(6)),

      reasons: unique(card.reasons),

      components: clone(card.components),

      placement: options.placement,

      strategy: options.strategy,

      recommendationId: definition.id,

      product: clone(card.candidate)

    };

  }

 

  function runRegisteredStrategy(strategyName, payload) {

    var strategy = registries.strategies.get(strategyName);

    if (!strategy) return null;

 

    try {

      return strategy(clone(payload));

    } catch (error) {

      warn("Recommendation strategy failed.", { strategy: strategyName, error: error && error.message });

      return null;

    }

  }

 

  function recommend(request) {

    request = isObject(request) ? request : {};

    var definition = resolveDefinition(request);

 

    if (definition.enabled === false) {

      return {

        id: definition.id,

        placement: definition.placement,

        strategy: definition.strategy,

        recommendations: [],

        generatedAt: new Date().toISOString(),

        disabled: true

      };

    }

 

    var context = deepMerge({}, request.context || {}, request);

    var options = deepMerge({}, DEFAULTS, definition, request);

    options.weights = deepMerge({}, DEFAULTS.weights, definition.weights || {}, request.weights || {});

    options.limit = Math.max(0, Math.floor(numberOr(request.limit, definition.limit)));

    options.placement = normalizeId(request.placement || definition.placement || DEFAULTS.placement);

    options.strategy = request.strategy || definition.strategy || DEFAULTS.strategy;

 

    var resolved = resolveState(context);

    context.currentProductId = normalizeId(context.currentProductId || resolved.currentProductId);

    context.currentCategoryId = normalizeId(context.currentCategoryId || resolved.currentCategoryId);

    context.cartItems = context.cartItems || resolved.cartItems;

 

    var key = cacheKey(definition, request, resolved, options);

    if (key && cache.has(key)) return clone(cache.get(key));

 

    var strategyResult = runRegisteredStrategy(options.strategy, {

      definition: definition,

      request: request,

      context: context,

      resolvedState: resolved,

      products: getProducts(),

      categories: getCategories(),

      defaults: clone(DEFAULTS)

    });

 

    var rankedCards;

 

    if (Array.isArray(strategyResult)) {

      rankedCards = strategyResult.map(function (entry) {

        if (entry && entry.candidate && entry.id) return entry;

        var product = registries.products.get(normalizeId(entry.id || entry.productId || entry));

        var card = createScoreCard(product || normalizeProduct(entry));

        card.score = numberOr(entry.score, 0);

        card.reasons = toArray(entry.reasons);

        return card;

      });

    } else {

      var candidates = generateCandidates(definition, context);

      var filtered = filterCandidates(candidates, definition, context, resolved, options);

      var scored = filtered.map(function (candidate) {

        return scoreCandidate(candidate, definition, context, resolved, options);

      });

 

      rankedCards = rank(scored, {

        seed: request.seed || definition.seed || options.placement + "|" + definition.id,

        deterministic: options.deterministic,

        minimumScore: options.minimumScore,

        limit: options.limit

      });

    }

 

    var recommendations = rankedCards

      .slice(0, options.limit)

      .map(function (card, index) {

        return formatResult(card, index, definition, options);

      });

 

    var result = {

      id: definition.id,

      placement: options.placement,

      strategy: options.strategy,

      recommendations: recommendations,

      count: recommendations.length,

      generatedAt: new Date().toISOString(),

      context: {

        currentProductId: resolved.currentProductId || null,

        currentCategoryId: resolved.currentCategoryId || null,

        returningVisitor: resolved.returningVisitor

      }

    };

 

    if (key) cache.set(key, clone(result));

 

    emit("recommendation-generated", {

      recommendationId: definition.id,

      placement: options.placement,

      strategy: options.strategy,

      count: recommendations.length,

      productIds: recommendations.map(function (item) { return item.id; })

    });

 

    emit("recommendation-ready", clone(result));

 

    return clone(result);

  }

 

  function registerStrategy(name, strategy) {

    var normalizedName = normalizeId(name);

    if (!normalizedName) throw new Error("Strategy requires a name.");

    if (typeof strategy !== "function") throw new TypeError("Strategy must be a function.");

 

    registries.strategies.set(normalizedName, strategy);

    cache.clear();

    return normalizedName;

  }

 

  function removeStrategy(name) {

    var removed = registries.strategies.delete(normalizeId(name));

    cache.clear();

    return removed;

  }

 

  function health() {

    return {

      name: ENGINE_NAME,

      version: VERSION,

      initialized: true,

      healthy: true,

      dependencies: {

        state: Boolean(root.state),

        events: Boolean(root.events),

        ruleEngine: Boolean(root.ruleEngine),

        personalizationEngine: Boolean(root.personalizationEngine)

      },

      counts: {

        recommendations: registries.recommendations.size,

        products: registries.products.size,

        categories: registries.categories.size,

        strategies: registries.strategies.size,

        cacheEntries: cache.size

      }

    };

  }

 

  function test() {

    var snapshot = {

      recommendations: new Map(registries.recommendations),

      products: new Map(registries.products),

      categories: new Map(registries.categories),

      cache: new Map(cache),

      sequence: sequence

    };

 

    try {

      clear();

      registerProducts([

        { id: "alpha", categoryIds: ["one"], flavorTags: ["vanilla"], dietaryTags: ["gluten-free"], crossSellIds: ["beta"] },

        { id: "beta", categoryIds: ["two"], flavorTags: ["chocolate"], dietaryTags: ["gluten-free"], popularity: 2 },

        { id: "gamma", categoryIds: ["one"], flavorTags: ["vanilla"], dietaryTags: ["contains-gluten"], available: false }

      ]);

      register({ id: "self-test", limit: 2 });

 

      var result = recommend({

        id: "self-test",

        currentProductId: "alpha",

        seedProductIds: ["alpha"],

        dietaryPreferences: ["gluten-free"],

        excludeUnavailable: true

      });

 

      var passed = result.recommendations.length === 1 && result.recommendations[0].id === "beta";

      return {

        passed: passed,

        assertions: {

          excludedCurrentProduct: result.recommendations.every(function (item) { return item.id !== "alpha"; }),

          excludedUnavailable: result.recommendations.every(function (item) { return item.id !== "gamma"; }),

          rankedCrossSell: result.recommendations[0] && result.recommendations[0].id === "beta"

        },

        result: result

      };

    } finally {

      registries.recommendations = snapshot.recommendations;

      registries.products = snapshot.products;

      registries.categories = snapshot.categories;

      cache = snapshot.cache;

      sequence = snapshot.sequence;

    }

  }

 

  var api = {

    name: ENGINE_NAME,

    version: VERSION,

    initialized: true,

    dependencies: ["DHCommerce.state", "DHCommerce.ruleEngine", "DHCommerce.personalizationEngine"],

 

    register: register,

    registerMany: registerMany,

    remove: remove,

    recommend: recommend,

    rank: rank,

    get: get,

    getAll: getAll,

    clear: clear,

 

    registerProduct: registerProduct,

    registerProducts: registerProducts,

    getProduct: getProduct,

    getProducts: getProducts,

 

    registerCategory: registerCategory,

    registerCategories: registerCategories,

    getCategory: getCategory,

    getCategories: getCategories,

 

    registerStrategy: registerStrategy,

    removeStrategy: removeStrategy,

 

    health: health,

    test: test,

 

    defaults: clone(DEFAULTS)

  };

 

  Object.defineProperty(api, "_registries", {

    enumerable: false,

    configurable: false,

    get: function () {

      return {

        recommendations: registries.recommendations,

        products: registries.products,

        categories: registries.categories,

        strategies: registries.strategies

      };

    }

  });

 

  root[ENGINE_NAME] = Object.freeze(api);

 

  emit("recommendation-engine-ready", {

    name: ENGINE_NAME,

    version: VERSION,

    dormant: true

  });

 

}(window, document));

